import { MinimumOrderQuantityType } from '../constant';
import { useOptions } from '../queries/useOptions';

export const useCommonService = () => {
  const {
    options: {
      catalog_product: { minimum_order_quantity_type },
    },
  } = useOptions();
  const isOrderQuantityProductType = minimum_order_quantity_type === MinimumOrderQuantityType.PRODUCT;
  const isOrderQuantityItemType = minimum_order_quantity_type === MinimumOrderQuantityType.ITEM;

  return {
    isOrderQuantityProductType,
    isOrderQuantityItemType,
  };
};
